































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class OutfixProductExpand extends Vue {
  @Prop({ type: Object, default: {} }) row: object
}
